(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-tabs"] && !Shopify.designMode) return;
  try {
    
  'use strict';

function Tabs() {
  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
    defaultTabs();
  }
  var defaultTabs = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    menuElements[0].classList.add('active');
      var id = menuElements[0].getAttribute('data-tab');
      document.getElementById(id).classList.add('active');
  }

  var clear = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-tab');
      document.getElementById(id).classList.remove('active');
    }
  }

  var change = function(e) {
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-tab');
    document.getElementById(id).classList.add('active');
    // setTimeout(function() {window.scrollTo(0, 0);}, 1);
  }
  bindAll();
    if(window.location.href.indexOf("content-0c084266-7de3-4b10-903f-71dad19382a2") > -1) {
      clear();
      var menuElements = document.querySelectorAll('[data-tab]');
    menuElements[1].classList.add('active');
      var id = menuElements[1].getAttribute('data-tab');
      document.getElementById('content-0c084266-7de3-4b10-903f-71dad19382a2').classList.add('active');
    }
}
var connectTabs = new Tabs();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-category-featured-collection"] && !Shopify.designMode) return;
  try {
    
  'use strict';

function Tabs() {
  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-category-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
    defaultTabs();
  }
  var defaultTabs = function() {
    var menuElements = document.querySelectorAll('[data-category-tab]');
    menuElements[0].classList.add('active');
      var id = menuElements[0].getAttribute('data-category-tab');
      document.getElementById(id).classList.add('active');
  }

  var clear = function() {
    var menuElements = document.querySelectorAll('[data-category-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-category-tab');
      document.getElementById(id).classList.remove('active');
    }
  }

  var change = function(e) {
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-category-tab');
    document.getElementById(id).classList.add('active');
    // setTimeout(function() {window.scrollTo(0, 0);}, 1);
  }
  bindAll();
}
var connectTabs = new Tabs();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-category-featured-products"] && !Shopify.designMode) return;
  try {
    
  'use strict';

function Tabs() {
  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
    defaultTabs();
  }
  var defaultTabs = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    menuElements[0].classList.add('active');
      var id = menuElements[0].getAttribute('data-tab');
      document.getElementById(id).classList.add('active');
  }

  var clear = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-tab');
      document.getElementById(id).classList.remove('active');
    }
  }

  var change = function(e) {
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-tab');
    document.getElementById(id).classList.add('active');
    // setTimeout(function() {window.scrollTo(0, 0);}, 1);
  }
  bindAll();
}
var connectTabs = new Tabs();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-featured-collection"] && !Shopify.designMode) return;
  try {
    
  'use strict';

function Tabs() {
  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    var prevTab = document.querySelectorAll('[data-prev-tab]');
    var nextTab = document.querySelectorAll('[data-next-tab]');
    
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
      prevTab[i].addEventListener('click', prev, false);
      nextTab[i].addEventListener('click', next, false);
    }
    defaultTabs();
  }
  var defaultTabs = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    menuElements[0].classList.add('active');
      var id = menuElements[0].getAttribute('data-tab');
      document.getElementById(id).classList.add('active');
  }

  var clear = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-tab');
      document.getElementById(id).classList.remove('active');
    }
  }

  var change = function(e) {
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-tab');
    document.getElementById(id).classList.add('active');
    // setTimeout(function() {window.scrollTo(0, 0);}, 1);
  }
  var prev = function(e) {
    var index = Number(e.target.dataset.index);
    var nextIndex = index-1;
    var len = Number(e.target.dataset.length)
    if (index-1 <0) {
      nextIndex = len-1
    }
    var tab = document.getElementById("tab-"+nextIndex);
    tab.click();
  }
  var next = function(e) {
    var index = Number(e.target.dataset.index);
    var len = Number(e.target.dataset.length)
    var nextIndex = index+1;
    if (index+1 > len-1) {
      nextIndex = 0
    }
    var tab = document.getElementById("tab-"+nextIndex);
    tab.click();
  }
  bindAll();
}
var connectTabs = new Tabs();


  } catch(e) { console.error(e); }
})();
})();
